import { gql } from '@urql/core';

export const GET_MERCHANT_REVIEWS = gql`
  query GetMerchantReviews($options: ReviewListOptions) {
    merchantReviews(options: $options) {
      items {
        id
        createdAt
        productId
        customerId
        rating
        title
        body
        isVerifiedPurchase
        state
        helpfulCount
        notHelpfulCount
        reportCount
        merchantReply
        merchantReplyAt
        customerName
        productName
      }
      totalItems
    }
  }
`;

export const GET_REVIEW_DETAIL = gql`
  query GetReviewDetail($id: ID!) {
    reviewDetail(id: $id) {
      id
      createdAt
      updatedAt
      productId
      customerId
      rating
      title
      body
      isVerifiedPurchase
      state
      helpfulCount
      notHelpfulCount
      reportCount
      merchantReply
      merchantReplyAt
      moderatedBy
      moderatedAt
      rejectionReason
      customerName
      productName
    }
  }
`;

export const GET_REVIEW_STATS = gql`
  query GetReviewStats {
    reviewStats {
      total
      pending
      approved
      rejected
      flagged
    }
  }
`;

export const APPROVE_REVIEW = gql`
  mutation ApproveReview($id: ID!) {
    approveReview(id: $id) {
      success
      errorCode
      review {
        id
        state
        moderatedAt
      }
    }
  }
`;

export const REJECT_REVIEW = gql`
  mutation RejectReview($id: ID!, $reason: String) {
    rejectReview(id: $id, reason: $reason) {
      success
      errorCode
      review {
        id
        state
        moderatedAt
        rejectionReason
      }
    }
  }
`;

export const BULK_APPROVE_REVIEWS = gql`
  mutation BulkApproveReviews($ids: [ID!]!) {
    bulkApproveReviews(ids: $ids) {
      success
      count
    }
  }
`;

export const BULK_REJECT_REVIEWS = gql`
  mutation BulkRejectReviews($ids: [ID!]!, $reason: String) {
    bulkRejectReviews(ids: $ids, reason: $reason) {
      success
      count
    }
  }
`;

export const REPLY_TO_REVIEW = gql`
  mutation ReplyToReview($id: ID!, $body: String!) {
    replyToReview(id: $id, body: $body) {
      success
      errorCode
      review {
        id
        merchantReply
        merchantReplyAt
      }
    }
  }
`;

export const DELETE_REVIEW_REPLY = gql`
  mutation DeleteReviewReply($id: ID!) {
    deleteReviewReply(id: $id) {
      success
      errorCode
    }
  }
`;

export const GET_REVIEW_SETTINGS = gql`
  query GetReviewSettings {
    reviewSettings {
      id
      channelId
      enabled
      autoApprove
      requireVerifiedPurchase
      allowPhotos
      maxPhotos
      requireTitle
      requireBody
      minBodyLength
      customerEditWindowDays
      reviewRequestDelayDays
      reviewRequestUsePlatformSender
    }
  }
`;

export const UPDATE_REVIEW_SETTINGS = gql`
  mutation UpdateReviewSettings($input: UpdateReviewSettingsInput!) {
    updateReviewSettings(input: $input) {
      id
      enabled
      autoApprove
      requireVerifiedPurchase
      allowPhotos
      maxPhotos
      requireTitle
      requireBody
      minBodyLength
      customerEditWindowDays
      reviewRequestDelayDays
      reviewRequestUsePlatformSender
    }
  }
`;

export const GET_REVIEW_REQUESTS = gql`
  query GetReviewRequests($options: ReviewRequestListOptions) {
    reviewRequests(options: $options) {
      items {
        id
        createdAt
        updatedAt
        orderId
        customerId
        triggerEvent
        scheduledFor
        state
        sentAt
        orderCode
        customerEmail
        customerName
      }
      totalItems
    }
  }
`;

export const GET_REVIEW_REQUEST_STATS = gql`
  query GetReviewRequestStats {
    reviewRequestStats {
      pending
      sent
      cancelled
    }
  }
`;

export const CANCEL_REVIEW_REQUEST = gql`
  mutation CancelReviewRequest($id: ID!) {
    cancelReviewRequest(id: $id) {
      success
      errorCode
    }
  }
`;
